/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { gql } from "@apollo/client";
import { Provider, useResourceTypesQuery } from "~/generated/graphql";

gql`
  query ResourceTypes($provider: [Provider!], $categoryIDs: [ID!]) {
    resourceTypes(provider: $provider, categoryIDs: $categoryIDs)
  }
`;

export function useResourceTypeOptions(
  filterOut: string[] = [],
  provider?: Provider[],
  categoryIDs?: string[]
) {
  const { data, loading, error } = useResourceTypesQuery({
    variables: {
      provider,
      categoryIDs,
    },
  });

  const options =
    data?.resourceTypes
      .filter((type) => !filterOut.includes(type))
      .map((resourceType) => ({
        value: resourceType,
        label: resourceType,
      })) ?? [];

  return {
    options,
    loading,
    error,
  };
}
